import { render, staticRenderFns } from "./BestCategories.vue?vue&type=template&id=c848b43e&scoped=true"
import script from "./BestCategories.vue?vue&type=script&lang=js"
export * from "./BestCategories.vue?vue&type=script&lang=js"
import style0 from "./BestCategories.vue?vue&type=style&index=0&id=c848b43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c848b43e",
  null
  
)

export default component.exports